import React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App/App";
import "./style.css";
import "./styles/index.scss";
// Supports weights 300-800
import "@fontsource-variable/open-sans";
import { BrowserRouter } from "react-router-dom";
import setupLocatorUI from "@locator/runtime";
import { Auth0ProviderWithHistory } from "./components/Auth0ProviderWithHistory/Auth0ProviderWithHistory";
import { UserProvider } from "./context/user_context";
import AuthWrapper from "./components/AuthWrapper/AuthWrapper";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./utils/tanstack-query.utils";

if (process.env.NODE_ENV === "development") {
  setupLocatorUI();
}

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter
      future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
    >
      <Auth0ProviderWithHistory>
        <AuthWrapper>
          <UserProvider>
            <App />
          </UserProvider>
        </AuthWrapper>
      </Auth0ProviderWithHistory>
    </BrowserRouter>
  </QueryClientProvider>
);

// Legacy rendering method
// if (rootElement.hasChildNodes()) {
//   hydrate(
//     <BrowserRouter>
//       <Auth0ProviderWithHistory>
//         <AuthWrapper>
//           <UserProvider>
//             <App />
//           </UserProvider>
//         </AuthWrapper>
//       </Auth0ProviderWithHistory>
//     </BrowserRouter>,
//     rootElement
//   );
// } else {
//   render(
//     <BrowserRouter>
//       <Auth0ProviderWithHistory>
//         <AuthWrapper>
//           <UserProvider>
//             <App />
//           </UserProvider>
//         </AuthWrapper>
//       </Auth0ProviderWithHistory>
//     </BrowserRouter>,
//     rootElement
//   );
// }
